import { CloseIconBasic } from "../../../../src/examples/utilities/CloseIcon";
import * as React from 'react';
export default {
  CloseIconBasic,
  React
};